<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="solution-banner">
      <div ref="testref">
        <div class="solution-title">体系化·高效化·科学化</div>
        <div class="solution-title2">依托于一套完备的预应力工程全数量无人化检测装备体系，实现质量评价体系化、控制管理高效化、品质提升科学化</div>
      </div>
    </div>

    <div class="solution-content">
      <div>
        <div class="title-s1" ref="test2ref" id="index1" >行业挑战</div>
        <div class="solution-content-ul" >
          <div class="solution-content-li" :class="{'title-s1':testShow2}">
            <div class="san"></div>
            <div class="san1">1</div>
            <div class="t1">工程行业特点与挑战</div>
            <div class="t2">特点</div>
            <div class="t3">基建大国</div>
            <div class="t3">数量多、规模大、进步快</div>

            <img src="@/assets/imgs/solution/2.png" />
            <div class="t2">挑战</div>
            <div class="t3">劳动生产效率低、产值利润率低</div>
            <div class="t3">资源消耗大、浪费现象严重</div>
            <div class="t3">劳动环境恶劣（危、繁、重、苦）</div>
          </div>
          <div class="solution-content-li" :class="{'title-s1':testShow2}">
            <div class="san"></div>
            <div class="san1">2</div>
            <div class="t1">预应力工程行业特点与挑战</div>
            <div class="t2">特点</div>
            <div class="t3">技术经济优势显著</div>
            <div class="t3">应用领域广泛、发展进步迅速</div>


            <img src="@/assets/imgs/solution/2.png" />
            <div class="t2" >挑战</div>
            <div class="t3">专业性强、工艺工序多、技术要求高</div>
            <div class="t3">隐蔽性强、质量控制难</div>
            <div class="t3">应用需求差异化大、技术发展不平衡</div>
            <div class="t3">质量安全隐患多、事故责任重、损失影响大</div>
          </div>
          <div class="solution-content-li" :class="{'title-s1':testShow2}">
            <div class="san"></div>
            <div class="san1">3</div>
            <div class="t1">预应力工程质量检测行业机遇</div>
            <div class="t2">机遇</div>
            <div class="t3">行业发展转型升级，迫切需要实现高质量发展，打造品质工程</div>
            <div class="t3">新一轮数字科技革命将为工程建设行业带来新的创新驱动力</div>
            <div class="t3">新一代信息技术与检测技术的深度融合将彻底变革传统工程检测模式</div>

            <img src="@/assets/imgs/solution/2.png"  />
            <div class="t2">挑战</div>
            <div class="t3">理论、技术、规范体系还尚待完善</div>
            <div class="t3">预应力专项作业技术要求高、工况环境差、危险系数大</div>
            <div class="t3">重要工艺环节隐蔽性强、时间窗口窄，传统方式检不了、
              检不准、检得慢、费用高</div>
            <div class="t3">参建各方均面临“决策层看不清、管理层管不住、执行层做不好”的突出问题</div>
          </div>
        </div>
      </div>
    </div>

    <div class="solution-content1">
      <div class="solution-content1-box">
        <div class="content1-t1">解决方案体系</div>
        <div class="content1-t2" style="text-align: left">在国家全面开展质量提升行动，实施质量强国战略时代背景下，顺应新基建“数字化、网络化、智能化”三化融合的发展趋势，为从本质上杜绝重大质量事故和隐患，满足品质工程建设的需要，基于新发展理念，利用新技术和新装备，深度融合现代信息技术，构筑了一套以数字化为核心的“体系化、高效化、科学化”解决方案。</div>

      </div>
<!--  <img src="@/assets/imgs/solution/1.png" style="width: 100%" />-->
    </div>

    <div class="solution-content2">
      <div>
        <div class="content2-title2" id="index2">方案优势</div>
        <div class="left-li1-title">数字化方案</div>
        <div class="solution-content2-li flex">
          <div class="left">

            <div class="left-li2" style="margin-top: 0.16rem;"> <span style="">过程阶段</span></div>
            <div class="left-li2" style="margin-top: 0.26rem;"><img  src="@/assets/imgs/solution/yes.png" /><span>测量记录</span></div>
            <div class="left-li2"  style="margin-top: 0.54rem;"><img  src="@/assets/imgs/solution/yes.png" /> <span style="">结果评价</span></div>
            <div class="left-li2" style="margin-top: 0.57rem;"><img  src="@/assets/imgs/solution/yes.png" /> <span style="">质量控制</span></div>
            <div class="left-li2" style="margin-top: 0.57rem;"><img  src="@/assets/imgs/solution/yes.png" /> <span style="">品质提升</span></div>
          </div>
          <div class="center">
            <div class="center-li1">实施方式</div>
            <div  class="center-li2">物联网（IOT）终端远程自动采集</div>
            <div  class="center-li2">施工过程中全数量动态检测</div>
            <div  class="center-li2">云平台实时数据驱动和自动事件预警</div>
            <div  class="center-li2">大数据全维度智能分析、决策及响应</div>
          </div>
          <div class="center" style="margin-left: .1rem">
            <div class="center-li1">优点</div>
            <div  class="center-li2">实时、完整、客观、无人</div>
            <div  class="center-li2">事中、全样、动态、节约</div>
            <div  class="center-li2">协同、及时、闭环、高效</div>
            <div  class="center-li2">全面、精准、持续、透明( 不隐瞒、不回避、不盲动）</div>
          </div>
        </div>
        <div class="left-li1-title" style="margin-top: 0.2rem">传统方案</div>
        <div class="solution-content2-li flex" >

          <div class="left">
            <div class="left-li2"  style="margin-top: 0.16rem;"><span style="">过程阶段</span></div>
            <div class="left-li2" style="margin-top: 0.2rem;"><img  src="@/assets/imgs/solution/no.png" /><span style="">测量记录</span></div>
            <div class="left-li2" style="margin-top: 0.26rem;"><img  src="@/assets/imgs/solution/no.png" /> <span style="">结果评价</span></div>
            <div class="left-li2" style="margin-top: 0.54rem;"><img  src="@/assets/imgs/solution/no.png" /> <span style="">质量控制</span></div>
            <div class="left-li2" style="margin-top: 0.54rem;"><img  src="@/assets/imgs/solution/no.png" /> <span style="">品质提升</span></div>
          </div>
          <div class="center">
            <div class="center-li1">实施方式</div>
            <div  class="center-li2">人工旁站监管记录</div>
            <div  class="center-li2">施工完后再现场抽样检测</div>
            <div  class="center-li2">依赖经验、责任感及强制措施</div>
            <div  class="center-li2">事后流程业务驱动</div>
          </div>
          <div class="center" style="margin-left: .1rem">
            <div class="center-li1">缺点</div>
            <div  class="center-li2">粗放、碎片、主观</div>
            <div  class="center-li2">费时、费力、费钱</div>
            <div  class="center-li2" style="margin-top: 0.5rem;">片面、波动、隐蔽</div>
            <div  class="center-li2" style="margin-top: 0.5rem;">迟滞、漏环、低效</div>
          </div>
        </div>
      </div>
    </div>

    <div class="solution-content3" id="index3">
      <div class="content3-t1">方案价值</div>
      <div class="flex" style="margin-top: 24px">
        <div class="content3-t2" style="width: 1.12rem">
          <span>价值层面</span>
          <span style=" margin-bottom: .7rem;">质量评价</span>
          <span style=" margin-bottom: 1.1rem;">控制管理</span>
          <span>品质提升</span>
        </div>
        <div class="content3-t2" style="width: 1.12rem;margin-left: 0.2rem">
          <span>意义导向</span>
          <span style=" margin-bottom: .7rem;">体系化</span>
          <span style=" margin-bottom: 1.1rem;">高效化</span>
          <span>科学化</span>
        </div>
        <div class="content3-t2" style="width: 3.22rem;margin-left: 0.2rem">
          <span>呈现方式</span>
          <span>六位一体、全时全维、客观真实</span>
          <span>施工即检测、动态反馈、预警实时、处理及时、有效闭环</span>
          <span>精准定位问题、科学分析研判原因、落实质量提升行动</span>
        </div>
      </div>
    </div>

    <div class="solution-content4">
      <div class="content3-t3">解决方案咨询</div>
      <div class="content3-t4">关于解决方案的更多咨询， 请联系我们的销售
        和技术支持团队</div>
      <router-link to="/contactUs" style="    text-decoration:none;">
        <div class="content3-t5 flex-center">联系我们</div>
      </router-link>
    </div>

    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  export default {
    name: 'wapSolution',
    components:{headers,footers},
    data() {
      return{
        testShow:false,
        testShow2:false,
        currentScroll:0
      }
    },
    created() {
      // window.addEventListener('scroll', this.handleScrollbox, true);
      this.$nextTick(() => {
        if( document.querySelector("#" + this.$route.query.index)){
          document.querySelector("#" + this.$route.query.index).scrollIntoView(true);
          this.$nextTick(() => {
            document.querySelector("#" + this.$route.query.index).scrollIntoView(true);
          })
        }
      })
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    },
    methods:{
      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        // if (this.currentScroll >= this.$refs.testref.offsetTop - 700) {
        //   //当前滚动位置到达testref的时候，显示div（100作为调整用）
        //   this.testShow = true
        // }

      },
    }
  }
  </script>

<style scoped>
  .solution-banner{
    width: 100%;
    background-image: url("../../assets/imgs/wap/3.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #F2F4F9;
    overflow: hidden;
    height: 13.34rem;
  }

 .solution-banner .solution-title{
   font-size: 0.48rem;
   font-family: PingFang SC-Heavy, PingFang SC;
   font-weight: 800;
   color: #19203B;
   width: 100%;
   margin-top: 3.2rem;
   padding:0.2rem 0.68rem;
   animation-name: fadeInUp;
   animation-duration:1s;
   animation-timing-function:ease;
   animation-fill-mode:forwards;

 }
  .solution-banner .solution-title2{
    font-size: 0.28rem;
    width: 5.4rem;
    animation-duration:1s;    opacity: 0;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    animation-name: fadeInUp;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 2;
    margin:0.8rem 0;
    padding:0 0.68rem;
    color: #19203B
  }

  .solution-content{
    background-color: #FFFFFF;
    padding: 0.6rem 0.72rem;
  }

  .solution-content .title-s1{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    text-align: center;
    margin-bottom: 0.4rem;
  }
  .solution-content .solution-content-li{
    background-color: #F3F2FB;
    padding: 0.4rem 0.54rem;
    margin-bottom: 0.2rem;
    text-align: center;
    position: relative;
  }
  .solution-content .solution-content-li .t1{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    text-align: center;
    line-height: 1.8;
    color: #19203B;
    margin-bottom: 0.4rem;
  }
  .solution-content .solution-content-li .t2{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin-bottom: 0.2rem;
    line-height: 1.8;
    text-align: left;
  }
  .solution-content .solution-content-li .t3,.solution-content .solution-content-li .t4{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 1.8;
    text-align: left;
    position: relative;
    padding-left: 0.4rem;
  }
  .solution-content .solution-content-li .t3:after{
    position: absolute;
    content: " ";
    left: 0;
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    background: #0071EF;
    top: 0.2rem;
  }
  .solution-content .solution-content-li img{
    width: 0.5rem;
    margin: 0.6rem auto 0;
  }

  .solution-content2{
    background-color: #F2F4F9;
    width: 100%;
    box-sizing: border-box;
    padding: 0.4rem 0.72rem;
  }
  .solution-content2 .left-li1-title{
    width: 6.04rem;
    height: 0.68rem;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #F2F2F2;
    background: #0071EF;
  }
  .solution-content .solution-content-li .san{
    background-image: url("../../assets/imgs/solution/7.png");
    position: absolute;
    height: 1rem;
    width: 1rem;
    top: 0;
    background-size: 100%;
    left: 0;

  }
  .solution-content .solution-content-li .san1{
    position: absolute;
    color: #ffffff;
    left: 0.2rem;
    top: 0.06rem;
    font-size: 0.36rem;
  }
  .solution-content2 .left{
    width: 1.3rem;
    background-color: #0071EF;
    color: #FFFFFF;
  }
  .solution-content2 .left img{
    width: 0.2rem;
  }
  .solution-content2 .left-li2{
    margin-bottom: 0.2rem;
    text-align: center;
  }
  .solution-content2 .left-li1{
    font-size: 0.28rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }
  .solution-content2 .center{
    width: 2.33rem;
    font-size: 0.24rem;
    padding: 0.14rem .2rem;
    box-sizing: border-box;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    background-color: #FFFFFF;
    color: #19203B;
  }
  .solution-content2 .left-li2{
    font-size: 0.24rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
  }
  .solution-content2 .content2-title2{
    font-size: 0.32rem;
    text-align: center;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin-bottom: 0.4rem;
  }
  .solution-content2 .center-li1{
    font-size: 0.28rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    margin-bottom: 0.2rem;
    color: #19203B;
  }
  .solution-content2 .center-li2{
    font-size: 0.24rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
    margin-bottom: 0.2rem;
  }

  .solution-content3{
    width: 100%;
    height: 6.32rem;
    background: linear-gradient(154deg, #34E4AA 0%, #2C68FF 100%);
    box-sizing: border-box;
    padding: 0.4rem .72rem;
  }

  .solution-content3 .content3-t1{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }
  .solution-content3 .content3-t2{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
  .solution-content3 .content3-t2 span{
    margin-bottom: .3rem;
    display: block;
  }
  .solution-content4{
    width: 100%;
    height: 3.56rem;
    background: #19203B;
    margin-top: 0.2rem;
    padding: 0.48rem 0.72rem;
    box-sizing: border-box;
    margin-bottom: 0.6rem;
  }
  .solution-content4 .content3-t3{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #F2F2F2;
  }
  .solution-content4 .content3-t4{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    margin-top: 0.4rem;
    color: #FFFFFF;
  }
  .solution-content4 .content3-t5{
    width: 1.36rem;
    height: 0.42rem;
    background: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%);
    border-radius: 1.72rem;
    font-size: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin: 0.4rem auto 0;
  }

  .solution-content1-box{
    background-color: RGBA(240, 245, 255, 1);
    width: 100%;
    font-size: 0.28rem;
    padding: 0.4rem 0.72rem;
    box-sizing: border-box;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #0071EF;
  }
  .solution-content1-box .content1-t1{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #0071EF;
    text-align: center;
    margin-bottom: 0.36rem;
  }
  .solution-content1-box .content1-t2{
    line-height: 2;
    color: rgba(0, 113, 239, 1);
  }
</style>



// WEBPACK FOOTER //
// src/view/solution/wapIndex.vue